import React from 'react';
import RegionLink from 'Components/common/RegionLink';
import SmartText from '@reuters-graphics/react-smart-text';
import groupBy from 'lodash/groupBy';
import roundDown from 'Utils/roundDown';

// This is the top by the latest average (!)
const getTopRegion = (cases) => {
  const groupedByRegion = groupBy(cases, 'region');
  let topRegion = null;
  let topCount = 0;
  for (const region in groupedByRegion) {
    const total = groupedByRegion[region].slice(-7).reduce((a, d) => a + d.count, 0) / 7;
    if (total > topCount) {
      topRegion = region;
      topCount = total;
    }
  }
  return topRegion;
};

const getShareOfDaily = (cases, topRegion) => {
  const groupedByRegion = groupBy(cases, 'region');
  const latestReportingDates = [];
  // Get latest dates where more than 90% of countries in a region are logged
  for (const region in groupedByRegion) {
    const { date } = groupedByRegion[region].filter(a => a.reporting[1] / a.reporting[0] > 0.9)[0];
    latestReportingDates.push(date);
  }

  // Sort latest dates earliest to latest
  latestReportingDates.sort((a, b) => new Date(a) - new Date(b));

  // Use earliest latest date :)
  const latestReportingDate = latestReportingDates[0];

  let totalReportingForLatestDate = 0;
  let topRegionLatest = 0;
  for (const region in groupedByRegion) {
    const { count } = groupedByRegion[region].find(a => a.date === latestReportingDate);
    if (region === topRegion) topRegionLatest = count;
    totalReportingForLatestDate += count;
  }

  return topRegionLatest / totalReportingForLatestDate;
};

const getRegionTotal = (cases, topRegion) => cases
  .filter(c => c.region === topRegion)
  .reduce((a, c) => a + c.count, 0);

const getDaysForLastMillion = (cases, topRegion) => {
  const regionCases = cases
    .filter(c => c.region === topRegion)
    .filter(a => a.reporting[1] / a.reporting[0] > 0.9); // Complete days
  regionCases.sort((a, b) => new Date(b.date) - new Date(a.date));

  const oneDay = 24 * 60 * 60 * 1000;
  const latestDate = new Date(regionCases[0].date);
  let i = 0;
  let runningTotal = 0;
  while (runningTotal < 1000000) {
    runningTotal += regionCases[i].count;
    i += 1;
  }

  const dateMinusMillion = new Date(regionCases[i - 1].date);

  const daysForLastMillion = Math.ceil((latestDate - dateMinusMillion) / oneDay);

  return daysForLastMillion;
};

const Text = (props) => {
  const { source, cases, locale } = props;
  const topRegion = getTopRegion(cases);
  const topRegionShareOfLatestDate = getShareOfDaily(cases, topRegion);
  const topRegionTotal = getRegionTotal(cases, topRegion);
  const daysForLastMillion = getDaysForLastMillion(cases, topRegion);
  return (
    <SmartText
      source={source}
      context={{
        region: <RegionLink region={topRegion} locale={locale} />,
        share: Math.floor(topRegionShareOfLatestDate * 100).toLocaleString(locale),
        days: (daysForLastMillion).toLocaleString(locale),
        total: roundDown(topRegionTotal).toLocaleString(locale),
      }}
      multiline
    />
  );
};

export default Text;
